import { create } from 'zustand';

interface SseStoreState {
  settlementExportRefreshKey: number;
  settlementImportRefreshKey: number;
  reportGeneratedRefreshKey: number;
  reportGenerationStartedRefreshKey: number;
  branchesImportRefreshKey: number;
  receivedQuantitiesImportRefreshKey: number;
}

const useSseStore = create<SseStoreState>()(() => ({
  settlementExportRefreshKey: 0,
  settlementImportRefreshKey: 0,
  reportGeneratedRefreshKey: 0,
  reportGenerationStartedRefreshKey: 0,
  branchesImportRefreshKey: 0,
  receivedQuantitiesImportRefreshKey: 0,
}));

export function useSseState() {
  const state = useSseStore();
  return {
    get settlementExportRefreshKey() {
      return state.settlementExportRefreshKey;
    },
    setSettlementExportRefreshKey() {
      useSseStore.setState((s) => ({ settlementExportRefreshKey: s.settlementExportRefreshKey + 1 }));
    },
    get settlementImportRefreshKey() {
      return state.settlementImportRefreshKey;
    },
    setSettlementImportRefreshKey() {
      useSseStore.setState((s) => ({ settlementImportRefreshKey: s.settlementImportRefreshKey + 1 }));
    },
    get branchesImportRefreshKey() {
      return state.branchesImportRefreshKey;
    },
    setBranchesImportedRefreshKey() {
      useSseStore.setState((s) => ({ branchesImportRefreshKey: s.branchesImportRefreshKey + 1 }));
    },
    get reportGeneratedRefreshKey() {
      return state.reportGeneratedRefreshKey;
    },
    setReportGeneratedRefreshKey() {
      useSseStore.setState((s) => ({ reportGeneratedRefreshKey: s.reportGeneratedRefreshKey + 1 }));
    },
    get reportGenerationStartedRefreshKey() {
      return state.reportGenerationStartedRefreshKey;
    },
    setReportGenerationStartedRefreshKey() {
      useSseStore.setState((s) => ({ reportGenerationStartedRefreshKey: s.reportGenerationStartedRefreshKey + 1 }));
    },
    get receivedQuantitiesImportRefreshKey() {
      return state.receivedQuantitiesImportRefreshKey;
    },
    setRefreshReceivedQuantitiesImport() {
      useSseStore.setState((s) => ({ receivedQuantitiesImportRefreshKey: s.receivedQuantitiesImportRefreshKey + 1 }));
    },
  };
}
